/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FxIdDomainSettingsAdvertisementYandexOptionsRewarded } from './FxIdDomainSettingsAdvertisementYandexOptionsRewarded';
import {
    FxIdDomainSettingsAdvertisementYandexOptionsRewardedFromJSON,
    FxIdDomainSettingsAdvertisementYandexOptionsRewardedFromJSONTyped,
    FxIdDomainSettingsAdvertisementYandexOptionsRewardedToJSON,
    FxIdDomainSettingsAdvertisementYandexOptionsRewardedToJSONTyped,
} from './FxIdDomainSettingsAdvertisementYandexOptionsRewarded';

/**
 * 
 * @export
 * @interface FxIdDomainSettingsAdvertisementYandexOptions
 */
export interface FxIdDomainSettingsAdvertisementYandexOptions {
    /**
     * 
     * @type {FxIdDomainSettingsAdvertisementYandexOptionsRewarded}
     * @memberof FxIdDomainSettingsAdvertisementYandexOptions
     */
    Rewarded?: FxIdDomainSettingsAdvertisementYandexOptionsRewarded | null;
}

/**
 * Check if a given object implements the FxIdDomainSettingsAdvertisementYandexOptions interface.
 */
export function instanceOfFxIdDomainSettingsAdvertisementYandexOptions(value: object): value is FxIdDomainSettingsAdvertisementYandexOptions {
    return true;
}

export function FxIdDomainSettingsAdvertisementYandexOptionsFromJSON(json: any): FxIdDomainSettingsAdvertisementYandexOptions {
    return FxIdDomainSettingsAdvertisementYandexOptionsFromJSONTyped(json, false);
}

export function FxIdDomainSettingsAdvertisementYandexOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainSettingsAdvertisementYandexOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'Rewarded': json['Rewarded'] == null ? undefined : FxIdDomainSettingsAdvertisementYandexOptionsRewardedFromJSON(json['Rewarded']),
    };
}

export function FxIdDomainSettingsAdvertisementYandexOptionsToJSON(json: any): FxIdDomainSettingsAdvertisementYandexOptions {
    return FxIdDomainSettingsAdvertisementYandexOptionsToJSONTyped(json, false);
}

export function FxIdDomainSettingsAdvertisementYandexOptionsToJSONTyped(value?: FxIdDomainSettingsAdvertisementYandexOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Rewarded': FxIdDomainSettingsAdvertisementYandexOptionsRewardedToJSON(value['Rewarded']),
    };
}

